import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const masterKeyCreated: CaseReducer<NinchatState> = (state) => state
